module.exports = __webpack_public_path__ + "../resources/img/ic_fold_left_disabled.a1409885.svg";